import React, { useState } from "react";
import "../styles/Contact.css";
import {
  FaEnvelope,
  FaWhatsapp,
  FaGlobe,
  FaMapMarkerAlt,
} from "react-icons/fa";

const Contact = () => {
  const [showThankYou, setShowThankYou] = useState(false);

  return (
    <section id="contact" className="contact">
      <div className="container">
        <h2>Get in Touch</h2>

        <div className="contact-content">
          <aside className="contact-info">
            <h3>Contact Information</h3>
            <div className="contact-details">
              <div className="contact-item">
                <FaEnvelope className="icon" />
                <div>
                  <h4>Binu Varghese</h4>
                  <a href="mailto:binu@success-station.in">
                    binu@success-station.in
                  </a>
                  <a href="mailto:binumentor@gmail.com">binumentor@gmail.com</a>
                </div>
              </div>

              <div className="contact-item">
                <FaWhatsapp className="icon" />
                <a
                  href="https://wa.me/919008322217"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  +91 9008322217
                </a>
              </div>

              <div className="contact-item">
                <FaGlobe className="icon" />
                <a
                  href="https://www.success-station.in"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  www.success-station.in
                </a>
              </div>

              <div className="contact-item">
                <FaMapMarkerAlt className="icon" />
                <div>
                  <h4>Office Address</h4>
                  <p>
                    SUCCESS STATION
                    <br />
                    In front of Indian Coffee House Sadar,
                    <br />
                    Next to DTDC Couriers- Jabalpur,
                    <br />- 482001
                  </p>
                </div>
              </div>
            </div>
          </aside>

          <form
            action="https://formsubmit.co/binumentor@gmail.com"
            method="POST"
            className="contact-form"
            onSubmit={() => setShowThankYou(true)}
          >
            <h3>Send us a Message</h3>

            {/* Honeypot to prevent spam */}
            <input type="text" name="_honey" style={{ display: "none" }} />

            {/* Disable Captcha */}
            <input type="hidden" name="_captcha" value="false" />

            <input type="text" name="name" placeholder="Your Name" required />
            <input
              type="email"
              name="email"
              placeholder="Your Email"
              required
            />
            <input
              type="tel"
              name="phone"
              placeholder="Your Phone"
              maxLength={10}
              minLength={10}
              pattern="[0-9]{10}"
              inputMode="numeric"
              title="Please enter a 10-digit phone number"
            />
            <textarea name="message" placeholder="Your Message" required />
            <button type="submit" className="cta-button">
              Send Message
            </button>
          </form>
          {showThankYou && (
            <div className="thank-you-popup">Thanks for submitting!</div>
          )}
        </div>
      </div>
    </section>
  );
};

export default Contact;
